import styled from 'styled-components';

export const Ticket = styled.div`
  font-family: 'Roboto';

  p {
    font-weight: 900 !important;
  }

  img {
    width: 32px;
    height: 32px;
  }

  .bg-icon {
    background-color: rgba(255, 255, 255, 0.25);
    border-radius: 8px;
    margin: 20px;
  }

  .bg-color-orange {
    background-color: #ff842f;
    border-radius: 8px;
  }

  .bg-color-blue {
    background-color: #00a3e0;
    border-radius: 8px;
  }
`;
